<template>
  <form @submit.prevent="submit" autocomplete="off">
    <FormSelect2
      :options="loginableClientsOptions"
      name="clientId"
      v-model="fields.clientId"
      testId="clientId-input"
      label="Default Client"
      :errors="validation.fields.clientId.errors"
      :dirty="validation.fields.clientId.dirty"
      :disabled="loading"
      noneLabel="- Select a Client -"
    />
    <div class="form-buttons">
      <Btn
        class="me-2"
        variant="secondary"
        type="button"
        :disabled="loading"
        @click="cancel"
        data-test=""
      >
        Cancel
      </Btn>
      <Btn variant="primary" type="submit" :disabled="loading" :loading="loading" data-test="">
        Update Default Client
      </Btn>
    </div>
  </form>
</template>

<script>
import { computed, reactive, ref } from "vue";
import Btn from "@/components/display/Btn";
// import FormInput from "@/components/display/form/FormInput";
import FormSelect2 from "@/components/display/form/FormSelect2";
import store from "@/store";
import useValidator from "@/utils/useValidator";
import { validations as validationRules } from "leatherman-js";

export default {
  name: "UserDefaultClientForm",
  components: {
    // FormInput,
    FormSelect2,
    Btn,
  },
  emits: ["close", "confirm"],
  setup(props, { emit }) {
    const loading = ref(false);
    const errors = ref(null);
    // const dirty = ref(false);
    const fields = reactive({
      id: store.state.auth.user?.id,
      clientId: store.state.auth.user?.defaultClientId || null,
    });
    const { validator } = useValidator();
    const validation = validator(
      fields,
      validationRules.forms.userDefaultClient,
      {},
      {
        clientId: {
          required: "Client ID is required.",
        },
      }
    );

    const loginableClientsOptions = computed(() => {
      if (!store.state.auth.user?.loginableClients) {
        return;
      }

      console.log(store.state.auth.user?.loginableClients);

      // return [];

      return store.state.auth.user.loginableClients.map((item) => ({
        value: item.id,
        label: item.identity,
      }));
    });

    const cancel = () => emit("close");

    const submit = () => {
      errors.value = null;

      validation
        .validate()
        .then(() => {
          loading.value = true;
          store
            .dispatch("auth/changeDefaultClient", fields)
            .then(() => {
              store.dispatch("toasts/addToast", {
                variant: "success",
                message: "Successfully updated default client",
              });
              emit("confirm");
            })
            .catch(() => {
              store.dispatch("toasts/addToast", {
                variant: "error",
                message: "Error updating default client",
              });
            })
            .finally(() => {
              loading.value = false;
            });
        })
        .catch(() => {});
    };

    return {
      errors,
      fields,
      loading,
      submit,
      validation,
      cancel,
      loginableClientsOptions,
    };
  },
};
</script>
